$('.user-edit-row').on('click', function(){
  let url = $(this).data('url');
  window.location.href = url;
});


$(".delete-user").click(function(){
    return confirm("Voulez vous supprimer cet utilisateur ?");
});
